import { Agent, AgentPermission } from "~/services/agents";

// Sharing an agent maps to the manager-only `can_share` grant, resolved per-agent
// by the API; editors, USER-level grants, and SYSTEM agents never confer it.
// Drives the per-agent Share action (and the Share modal).
export const useCanShareAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.permissions.includes(AgentPermission.CAN_SHARE);
